import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import 'react-toastify/dist/ReactToastify.css';
import './toastify-custom.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import {
  sendInstallIfFirstLaunch,
  sendOpenMobileIfNative,
  waitForAnalytics,
} from './hooks/useAnalytics';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

waitForAnalytics().then(() => {
  // Send analytics if installed and it's first launch
  sendInstallIfFirstLaunch();
  // Send analytics if native and it's startup launch
  sendOpenMobileIfNative();
});
